<template>
  <div class="flex flex-1 flex-col gap-64 p-16 text-center font-['Poppins'] text-16 text-[#071449] sm:gap-64">
    <div class="flex flex-1 flex-col items-center justify-center gap-24">
      <img
        role="presentation"
        class="w-full max-w-[300px] sm:mb-32 sm:max-w-[385px]"
        :src="getAssetFromCdn('img/under_construction.png')"
        alt="Under Construction"
      />
      <h1 v-if="status === 'noparams'" class="text-24 font-bold">
        {{ $t('generate.noparams.title') }}
      </h1>
      <Purify
        tag="p"
        class="leading-7"
        :content="
          status === 'maintenance'
            ? $t('generate.maintenance.title')
            : $t('generate.noparams.desc')
        "
      />
      <Button
        v-if="status === 'maintenance'"
        class="min-w-[148px]"
        @click="reloadPage"
      >
        {{ $t('generate.pages.payment.formError.retry') }}
      </Button>
    </div>
    <div class="flex justify-center py-16 md:py-32">
      <img
        :src="getAssetFromCdn('img/zotlo-logo.svg')"
        width="101"
        alt="Zotlo."
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getAssetFromCdn } from '@zotlo-shared/utils/helpers';
import Button from '@zotlo-shared/components/button/index.vue'

defineProps<{
  status: 'maintenance' | 'noparams'
}>();

function reloadPage() {
  window.location.reload()
}

useHead({
  link: [
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap'
    }
  ]
})
</script>
